var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M24.167 25.5a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15zm0-3a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9zm13.168-3.333C37.335 11.895 31.44 6 24.167 6 16.895 6 11 11.895 11 19.167c0 4.569 4.352 11.855 13.167 21.448 8.816-9.593 13.168-16.88 13.168-21.448zM24.167 45C13.39 33.731 8 25.12 8 19.167 8 10.238 15.238 3 24.167 3c8.93 0 16.168 7.238 16.168 16.167 0 5.953-5.39 14.564-16.168 25.833z"
  })));
};
export default SvgLocation;